import SpecSheet from "@/components/SpecSheet.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { builderCta } from "@/helpers/builder-init/index";
const colors = ["None", ...Object.keys(themeColors)];
export const specSheetInit = {
    component: SpecSheet,
    name: "SpecSheet",
    canHaveChildren: true,
    inputs: [
        {
            name: "desktopBackgroundImage",
            type: "file",
            helperText: "Allowed file types - .jpeg, .png, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "gif", "svg"]
        },
        {
            name: "mobileBackgroundImage",
            type: "file",
            helperText: "Allowed file types - .jpeg, .png, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "gif", "svg"]
        },
        {
            name: "headline",
            type: "string",
            defaultValue: ""
        },
        {
            name: "headlineColor",
            type: "string",
            defaultValue: "rothcoWhite",
            enum: colors
        },
        {
            name: "body",
            type: "string",
            defaultValue: ""
        },
        {
            name: "bodyColor",
            type: "string",
            defaultValue: "rothcoWhite",
            enum: colors
        },
        {
            name: "textAlign",
            type: "string",
            enum: ["left", "center", "right"],
            defaultValue: "left"
        },
        {
            name: "cta",
            type: "object",
            subFields: [...builderCta.subFields]
        },
        {
            name: 'mobileBadgesHidden',
            friendlyName: "Hide Badges On Mobile",
            type: 'boolean',
            default: false
        },
        {
            name: "rows",
            type: "list",
            subFields: [
                {
                    name: "heading",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "headingColor",
                    type: "string",
                    defaultValue: "rothcoWhite",
                    enum: colors
                },
                {
                    name: "subtext",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "subtextColor",
                    type: "string",
                    defaultValue: "rothcoWhite",
                    enum: colors
                },
                {
                    name: "image",
                    type: "file",
                    helperText: "Allowed file types - .jpeg, .png, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "gif", "svg"]
                },
                {
                    name: "imageAlt",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "textAlign",
                    type: "string",
                    enum: ["left", "center", "right"],
                    defaultValue: "left"
                },
                {
                    name: "pictureOrientation",
                    type: "string",
                    enum: ["left", "right"],
                    defaultValue: "left"
                }
            ]
        }
    ]
};
